







/* global google */
import { defineComponent, inject, onBeforeUnmount, onMounted, PropType, Ref, ref } from '@nuxtjs/composition-api'

import Coordinate from '@/interfaces/Coordinate'

export default defineComponent({
  props: {
    coordinate: {
      type: Object as PropType<Coordinate | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    const map = inject('map') as Ref<google.maps.Map | null>
    const el = ref<HTMLDivElement>()

    let popup: Popup | null = null

    class Popup extends google.maps.OverlayView {
      position: google.maps.LatLng
      containerDiv: HTMLDivElement

      constructor (position: google.maps.LatLng, content: HTMLDivElement) {
        super()
        this.position = position
        this.containerDiv = content

        // Optionally stop clicks, etc., from bubbling up to the map.
        Popup.preventMapHitsAndGesturesFrom(this.containerDiv)
      }

      onAdd () {
        this.getPanes().floatPane.appendChild(this.containerDiv)
      }

      onRemove () {
        if (!this.containerDiv.parentElement) return
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }

      draw () {
        const { x, y } = this.getProjection()
          .fromLatLngToDivPixel(this.position)
        const { abs } = Math
        const display = abs(x) < 1000 && abs(y) < 1000 ? 'block' : 'none'

        if (display === 'block') {
          this.containerDiv.style.left = `${x}px`
          this.containerDiv.style.top = `${y}px`
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display
        }
      }
    }

    onMounted(() => {
      if (!(el.value && props.coordinate)) return
      const { lat, lng } = props.coordinate
      popup = new Popup(
        new google.maps.LatLng({ lat, lng }),
        el.value,
      )
      popup.setMap(map.value)
    })

    onBeforeUnmount(() => popup?.setMap(null))

    return {
      el,
    }
  },
})
